import { call, put, takeEvery } from 'redux-saga/effects';
import { getUsersList } from '../../requests/get_users_list_request';
import { getUsersListSuccess, getUsersListFailure } from '../actions/get_users_list.actions';
import { GET_USERS_LIST } from '../constants/get_users_list.constants';

function* getUsersListRequest({ searchText }) {
    const { result, options } = yield call(getUsersList, searchText);
    result
        ? yield put(getUsersListSuccess(options))
        : yield put(getUsersListFailure('Something gone wrong!'));
}

export default function* getUsersListSaga() {
    yield takeEvery(GET_USERS_LIST, getUsersListRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/sagas/get_users_list.saga.js